const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms));
export default sleep;
